"use client";

/**
 * A 44px "‹ Back to the app" control for the public pages the phone Menu
 * links to (/support/, /privacy/). They live outside the Lightning shell, and
 * the iOS app has no back swipe, so a signed-in user needs a clear way back.
 * Renders nothing for visitors who are not signed in.
 *
 *   <BackToApp />
 */
import { useRouter } from "next/navigation";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";

export function BackToApp() {
  const { t } = useI18n();
  const { status } = useAuth();
  const router = useRouter();
  if (status !== "signed-in") return null;
  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) router.back();
        else router.push("/home/");
      }}
      className="-ms-2 -mb-6 inline-flex min-h-11 items-center gap-1 self-start rounded-lg px-2 text-sm font-semibold text-brand-text outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50"
    >
      <ChevronLeft aria-hidden="true" className="size-5 rtl:-scale-x-100" />
      {t("shell.mobile.backToApp")}
    </button>
  );
}
